// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DyskzzB41LkALTA2XioJ {
  position: relative;
  width: 100%;
  height: 85vh;
  overflow: hidden;
  text-align: center;
}
.DyskzzB41LkALTA2XioJ .gnSjDnSvFnetzzLkRRgd {
  width: 35rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -10%);
  z-index: 1000;
  margin-top: 10rem;
}
.DyskzzB41LkALTA2XioJ .WBUPoLGLPVO0zY9pbBUT {
  width: 85%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 1%;
  clip-path: polygon(85% 10%, 100% 0%, 100% 90%, 85% 100%, 15% 100%, 0% 90%, 0% 10%, 15% 0%);
}
.DyskzzB41LkALTA2XioJ .QNBspwgb7ectoaEi8BUm {
  bottom: 20px;
  color: white;
  text-align: center;
  z-index: 1000;
}

@media screen and (max-width: 768px) {
  .DyskzzB41LkALTA2XioJ {
    height: 30vh;
    width: 100%;
    position: relative;
    overflow: visible;
  }
  .DyskzzB41LkALTA2XioJ .gnSjDnSvFnetzzLkRRgd {
    width: 10rem;
    top: -2.8rem;
    left: 50%;
    transform: translate(-50%, 0);
    margin-top: 0;
    z-index: 3000;
    position: absolute;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VideoBanner/VideoBanner.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,iBAAA;AACJ;AAEE;EACE,UAAA;EACA,YAAA;EACA,oBAAA;EACG,iBAAA;EACH,iBAAA;EACA,0FAAA;AAAJ;AAGE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AADJ;;AAKA;EACE;IACE,YAAA;IACA,WAAA;IACA,kBAAA;IACA,iBAAA;EAFF;EAIE;IACE,YAAA;IACA,YAAA;IACA,SAAA;IACA,6BAAA;IACA,aAAA;IACA,aAAA;IACA,kBAAA;EAFJ;AACF","sourcesContent":[".videoBanner {\n  position: relative;\n  width: 100%;\n  height: 85vh;\n  overflow: hidden;\n  text-align: center;\n\n  .logo {\n    width: 35rem;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -10%);\n    z-index: 1000;\n    margin-top: 10rem;\n  }\n\n  .videoBannerVideo {\n    width: 85%;\n    height: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    border-radius: 1%;\n    clip-path: polygon(85% 10%, 100% 0%, 100% 90%, 85% 100%, 15% 100%, 0% 90%, 0% 10%, 15% 0%);\n  }\n\n  .videoBannerContent {\n    bottom: 20px;\n    color: white;\n    text-align: center;\n    z-index: 1000;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .videoBanner {\n    height: 30vh;\n    width: 100%;\n    position: relative;\n    overflow: visible;\n\n    .logo {\n      width: 10rem;\n      top: -2.8rem; \n      left: 50%;\n      transform: translate(-50%, 0);\n      margin-top: 0;\n      z-index: 3000; \n      position: absolute;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoBanner": `DyskzzB41LkALTA2XioJ`,
	"logo": `gnSjDnSvFnetzzLkRRgd`,
	"videoBannerVideo": `WBUPoLGLPVO0zY9pbBUT`,
	"videoBannerContent": `QNBspwgb7ectoaEi8BUm`
};
export default ___CSS_LOADER_EXPORT___;
